import React from 'react';
import Keno from '../../games/keno';
import { TicketsBlock } from '../../games/keno/betBlock/ticketsBlock';
import { AmountBlock } from '../../games/keno/betBlock/amountBlock';
import AddTicket from '../../games/keno/betBlock/ticketsBlock/addTicket';
import { BetButtonsBlock } from '../../games/keno/betBlock/betButtonsBlock';
import Numpad from '../numpad';

function MobileGame() {
  return (
    <>
      <Keno />
      <div className='keno-game-footer'>
        <div className='keno-game-footer-inner'>
          <div className='keno-bet-block'>
            <div className='keno-tickets-action-block'>
              <TicketsBlock />
              <AmountBlock />
            </div>
            <div className='keno-bet-buttons-block'>
              <BetButtonsBlock />
              <AddTicket />
            </div>
            <Numpad />
          </div>
        </div>
      </div>
    </>
  );
}
export default MobileGame;
